<template>
    <div class="content-header">
        <div class="shadow-layout">
            <div class="position-absolute box-layout">
                <div class="box-load">
                    <div id="loading" class="loader"></div>
                    <div class="text-load">
                        <span>Loading</span>
                        <span v-if="isUploading" class="text-load-sub">
                            {{ $t('general.upload_takes_time') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'Loading',
    data () {
        return {
        };
    },
    computed: {
        ...mapState([
            'isUploading',
        ]),
    },
    created () {
    },
    methods: {
    },
};
</script>



// WEBPACK FOOTER //
// src/views/common/Loading.vue